module.exports = {
  dollarUS: Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  }),
};
